/**
 * Created by Alican Köker on 2019-05-23.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {EdisonGameConfig} from "../EdisonGameConfig";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "../server/data/EdisonParsedInitData";
import {EdisonIndividualWPView} from "../winpresentation/individual/EdisonIndividualWPView";

export class EdisonWinWaysSign extends BaseView {

    private _layer:ScalableLayer;
    private _winWaysText:PIXI.BitmapText;
    private _winWaysSprite:PIXI.Sprite;
    private _winWaysContainerSprite:PIXI.Sprite;
    private _waysWonText:PIXI.BitmapText;
    private _waysWonSprite:PIXI.Sprite;
    private _waysWonContainerSprite:PIXI.Sprite;
    private _waysWon:number = 0;
    private _waysWonSpPosX:number = 0;
    private _waysWonTimeline:TimelineLite;
    private _isRestore:boolean = false;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _modeChangeAnimTimeline:TimelineLite;
    private _initialModeChangeTriggered:boolean = false;
    private _initResize:boolean = true;
    private _gameMode:EdisonGameMode;
    private _nextMode:EdisonGameMode;
    private _yPadding:number = 0;
    private _gameData:EdisonParsedGameData;
    private _switchEffectSpeed:number = .1;
    private _firstIteration:boolean = true;
    private _currentSymbol:string = "";

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.FOREGROUND.name);
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this.setNextMode(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this.reset();
        this._gameData = data;
        this._gameMode = data.mode;
        this._isRestore = false;
        this._firstIteration = true;
        this._waysWon = data && data.betWayWins && data.betWayWins[0] ? data.betWayWins[0].numberOfCombinations : 0;
        this._currentSymbol = "";
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._gameMode = data.mode;
    }

    private setNextMode(mode:EdisonGameMode):void {
        this._nextMode = mode;
    }

    protected initAnimations():void {
        this._winWaysText = new PIXI.BitmapText("243", {
            fontName : "WinWaysNumbers",
            fontSize : 34,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16),
        });
        this._winWaysText.anchor = new PIXI.Point(.5, .5);

        this._winWaysText.letterSpacing = -20;
        this._waysWon = 0;

        this._winWaysSprite = new PIXI.Sprite(GameResources.getTextures("winWaysImage")[0]);
        this._winWaysSprite.scale.set(.88);
        this._winWaysSprite.anchor.set(.5);
        this._winWaysContainerSprite = new PIXI.Sprite();

        this._winWaysContainerSprite.addChild(this._winWaysSprite);
        this._winWaysContainerSprite.addChild(this._winWaysText);


        this._waysWonText = new PIXI.BitmapText("243", {
            fontName : "WinWaysNumbers",
            fontSize : 34,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16),
            align : "center"
        });
        this._waysWonText.anchor = new PIXI.Point(.5, .5);

        this._waysWonText.letterSpacing = -20;

        this._waysWonSprite = new PIXI.Sprite(GameResources.getTextures("waysWonImage")[0]);
        this._waysWonSprite.scale.set(.88);
        this._waysWonSprite.anchor.set(.5);
        this._waysWonContainerSprite = new PIXI.Sprite();

        this._waysWonContainerSprite.addChild(this._waysWonSprite);
        this._waysWonContainerSprite.addChild(this._waysWonText);
        this._waysWonText.scale.set(1, 0);
        this._waysWonSprite.scale.set(1, 0);

        this._layer.addChild(this._winWaysContainerSprite);
        this._layer.addChild(this._waysWonContainerSprite);

        this.reposition();
    }

    protected onResize(resizeData:IResizeData):void {

        this._yPadding = resizeData.orientation === Orientation.PORTRAIT ? EdisonGameConfig.instance.REEL_AREA_PORTRAIT_TOP_PADDING_PORTRAIT - 8 : 0;

        if(this._orientation === resizeData.orientation && !this._initResize)
            return;

        this._initResize = false;

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
            this._gameMode = this._nextMode;
        }

        this._orientation = resizeData.orientation;

        this.reposition();
    }

    private reposition():void {
        this._winWaysText.position.set(567, 579 + this._yPadding);
        this._winWaysSprite.position.set(669, 578 + this._yPadding);
        this._waysWonText.position.set(560, 579 + this._yPadding);
        this._waysWonSpPosX = this._waysWonText.position.x + this._waysWon.toString().length * 10 + this._waysWonSprite.width / 2;
        this._waysWonSprite.position.set(this._waysWonSpPosX, 578 + this._yPadding);
    }

    public showWaysWon(nrOfWaysWon:number, symName:string):void {
        if(/*this._gameData && this._gameData.freespinsLeft > 0 && this._gameMode === EdisonGameMode.FREESPIN || */this._currentSymbol === symName)
            return;

        if(nrOfWaysWon > 1) {
            this._waysWonSprite.texture = GameResources.getTextures("waysWonImage")[0];
        } else {
            this._waysWonSprite.texture = GameResources.getTextures("wayWonImage")[0];
        }
        this._currentSymbol = symName;
        this._waysWon = nrOfWaysWon;

        this._waysWonText.text = nrOfWaysWon.toString();
        this.reposition();

        this._waysWonText.scale.set(1, 0);
        this._waysWonSprite.scale.set(1, 0);

        this._waysWonTimeline = new TimelineLite();

        if(this._firstIteration) {
            this._firstIteration = false;
            this._winWaysText.scale.set(1, 1);
            this._winWaysSprite.scale.set(1, .9);
            this._waysWonTimeline.add(() => {
                TweenLite.to(this._winWaysText.scale, this._switchEffectSpeed, {x : 1, y : 0});
                TweenLite.to(this._winWaysSprite.scale, this._switchEffectSpeed, {x : 1, y : 0});
            });
        } else {
            this._firstIteration = false;
            this._waysWonTimeline.add(() => {
                TweenLite.to(this._waysWonText.scale, this._switchEffectSpeed, {x : 1, y : 0});
                TweenLite.to(this._waysWonSprite.scale, this._switchEffectSpeed, {x : 1, y : 0});
            });
        }

        this._waysWonTimeline.add(() => {
            TweenLite.to(this._waysWonText.scale, this._switchEffectSpeed, {x : 1, y : 1});
            TweenLite.to(this._waysWonSprite.scale, this._switchEffectSpeed, {x : 1, y : .88});
        }, this._firstIteration ? this._switchEffectSpeed : 0);
    }

    public reset():void {
        if((this._gameData && this._gameData.totalWin === 0) || !this._gameData)
            return;

        if(this._waysWonTimeline && this._waysWonTimeline.isActive()) {
            this._waysWonTimeline.pause();
            this._waysWonTimeline.kill();
        }

        this.reposition();

        this._waysWonText.scale.set(1, 1);
        this._waysWonSprite.scale.set(1, .9);
        this._winWaysText.scale.set(1, 0);
        this._winWaysSprite.scale.set(1, 0);

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            TweenLite.to(this._waysWonText.scale, this._switchEffectSpeed, {x : 1, y : 0});
            TweenLite.to(this._waysWonSprite.scale, this._switchEffectSpeed, {x : 1, y : 0});
        }, this._switchEffectSpeed);

        tl.add(() => {
            TweenLite.to(this._winWaysText.scale, this._switchEffectSpeed, {x : 1, y : 1});
            TweenLite.to(this._winWaysSprite.scale, this._switchEffectSpeed, {x : 1, y : .88});
        }, 2 * this._switchEffectSpeed);
    }

}